

































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import Copy from "@/components/copy.vue";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
import ComposeHeader from "../../../components/project-compose-header.vue";
import TemplateTransferCmp from "./template-transfer-cmp.vue";
@Component({
  components: {
    ConfirmDialog,
    Copy,
    LeaveConfirm,
    ComposeHeader,
    TemplateTransferCmp
  }
})
export default class ResearchListCompose extends Vue {
  private projectId: any = "";
  private patientId: any = "";
  private patient: any = {};
  private groupId: any = "";
  // 左侧列表
  private openControl: any = [];
  private cInterview: any = {};
  private interviews: any[] = [];
  private templateId: any = "";
  private cTemplate: any = {};
  private cContent: any = {};
  // 确认弹窗
  private tempTemplate: any = {};
  private tempInterview: any = {};
  private confirmState: "save" = "save";
  private confirmVisible: boolean = false;
  private confirmTitle: any = "温馨提示";
  private confirmHelp: any = "当前内容还没有保存，请保存后离开";
  private ifShowLeaveConfirm: boolean = false;
  // 控制编辑
  private get composeDisabled() {
    return this.$store.state.researchListComposeDiabled;
  }
  private transferTemplateState(state) {
    let result = "";
    switch (state) {
      case "0":
        result = "未开始";
        break;
      case "5":
        result = "未完成";
        break;
      case "10":
        result = "已提交";
        break;
    }
    return result;
  }
  /**
   * @description 开始编辑
   */
  private startCompose() {
    switch (this.cTemplate.type) {
      case "患者基本信息":
        if (this.patient.can_edit) {
          this.$store.commit("updateResearchListComposeDiabled", false);
        } else {
          this.$message.warning("对不起，设备数据暂时不支持修改");
        }
        break;
      case "自定义模板":
        this.$store.commit("updateResearchListComposeDiabled", false);
        break;
      case "系统模板":
        if (this.cTemplate["名称"] === "体质辨识") {
          console.log("体质辨识");
        } else {
          this.$message.warning("对不起，设备数据暂时不支持修改");
        }

        break;
      case "量表模板":
        this.$store.commit("updateResearchListComposeDiabled", false);
        break;
    }
  }
  /**
   * @description 获取患者详情
   */
  private fetchPatient() {
    const loading = this.$loading({ text: "加载中" });
    const params: any = {
      params: {
        patient_id: this.patientId,
        project_id: this.projectId,
        group_id: this.groupId
      }
    };
    axios
      .get("api/project/patient", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          this.patient = data.data;
        });
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 获取模板
   */
  private fetchTemplates() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          patient_id: this.patientId,
          project_id: this.projectId,
          group_id: this.groupId
        }
      };
      const loading = this.$loading({ text: "加载中" });
      axios
        .get("api/project/yjdl/templates", params)
        .then(({ data }) => {
          resHandle(this, data).then(() => {
            this.interviews = data.data.interviews;
            this.interviews.unshift({
              name: "患者入组信息",
              value: [
                {
                  name: "患者基本信息",
                  type: "患者基本信息",
                  template_id: "patient_base_info",
                  状态: "10"
                }
              ]
            });
            this.openControl[0] = true;
            this.cInterview = this.interviews[0];
            this.cTemplate = this.cInterview.value[0];
            resolve();
          });
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 获取某个模板结构详情
   */
  private fetchContents(templateId) {
    if (templateId === "patient_base_info") {
      return;
    }
    const loading = this.$loading({ text: "加载中" });
    const params: any = {
      params: {
        patient_id: this.patientId,
        project_id: this.projectId,
        group_id: this.groupId,
        template_id: templateId
      }
    };
    axios
      .get("api/project/content", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          this.cContent = data.data;
        });
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 控制左侧列表展示
   */
  private triggerOpenInterview(index) {
    const currentIfOpen = this.openControl[index];
    this.openControl = [];
    this.openControl[index] = !currentIfOpen;
    this.$forceUpdate();
  }
  /**
   * @description 点选某个模板
   */
  private chooseCTemplate(template, interview) {
    if (this.composeDisabled) {
      this.cTemplate = template;
      this.cInterview = interview;
      this.fetchContents(this.cTemplate.template_id);
    } else {
      this.tempTemplate = template;
      this.tempInterview = interview;
      this.confirmState = "save";
      this.confirmTitle = "温馨提示";
      this.confirmHelp = "当前内容还没有保存，请保存后离开";
      this.confirmVisible = true;
    }
  }
  /**
   * @description 取消编辑
   */
  private cancel() {
    this.$store.commit("updateResearchListComposeDiabled", true);
  }
  /**
   * @description 保存函数
   */
  private save() {
    return new Promise((resolve, reject) => {
      switch (this.cTemplate.type) {
        case "患者基本信息":
          this.savePatientBaseInfo()
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
          break;
        case "自定义模板":
          this.saveCustomContent().then(() => {
            this.fetchTemplates()
              .then(() => {
                this.cContent = {};
                resolve();
              })
              .catch(() => {
                reject();
              });
          });
          break;
        case "量表模板":
          this.saveLiangbiaoContent().then(() => {
            this.fetchTemplates()
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
          });
          break;
      }
    });
  }
  /**
   * @description 保存患者基本信息
   */
  private savePatientBaseInfo() {
    return new Promise((resolve, reject) => {
      const params: any = this.patient;
      axios.put("api/project/patient", params).then(({ data }) => {
        resHandle(this, data)
          .then(() => {
            this.$message.success("编辑成功");
            this.$store.commit("updateResearchListComposeDiabled", true);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    });
  }
  /**
   * @description 保存自定义模板
   */
  private saveCustomContent() {
    const loading = this.$loading({ text: "加载中" });
    return new Promise((resolve, reject) => {
      const params: any = {
        patient_id: this.patientId,
        project_id: this.projectId,
        group_id: this.groupId,
        template_id: this.cTemplate.template_id,
        data: this.cTemplate["模板"]
      };
      if (this.cContent.content_id) {
        params["content_id"] = this.cContent.content_id;
      }
      axios
        .post("api/project/content", params)
        .then(({ data }) => {
          resHandle(this, data).then(() => {
            this.cContent.content_id = data.data.content_id;
            this.$store.commit("updateResearchListComposeDiabled", true);
            resolve();
          });
        })
        .finally(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 保存量表模板
   */
  private saveLiangbiaoContent() {
    const loading = this.$loading({ text: "加载中" });
    return new Promise((resolve, reject) => {
      const params: any = {
        patient_id: this.patientId,
        project_id: this.projectId,
        group_id: this.groupId,
        template_id: this.cTemplate.template_id,
        data: this.cTemplate["模板"]
      };
      if (this.cContent.content_id) {
        params["content_id"] = this.cContent.content_id;
      }
      axios
        .post("api/project/content", params)
        .then(({ data }) => {
          resHandle(this, data).then(() => {
            this.cContent = data.data;
            this.$store.commit("updateResearchListComposeDiabled", true);
            resolve();
          });
        })
        .finally(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 处理弹窗取消
   */
  private handleCancel() {
    this.$store.commit("updateResearchListComposeDiabled", true);
    this.confirmVisible = false;
    this.chooseCTemplate(this.tempTemplate, this.tempInterview);
  }
  /**
   * @description 处理弹窗确定
   */
  private handleConfirm() {
    switch (this.confirmState) {
      case "save":
        this.confirmVisible = false;
        break;
    }
  }

  /**
   * @description 离开保存
   */
  private leaveSave() {
    this.save().finally(() => {
      this.ifShowLeaveConfirm = false;
      this.$router.push("/main/project/research-list-folder/" + this.projectId);
    });
  }
  /**
   * @description 不保存离开
   */
  private leaveConfirmed() {
    this.$store.commit("updateResearchListComposeDiabled", true);
    this.$router.push("/main/project/research-list-folder/" + this.projectId);
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    const query = this.$route.query;
    this.projectId = query.project_id;
    this.patientId = query.patient_id;
    this.groupId = query.group_id;
    this.templateId = query.template_id || "";
    this.fetchPatient();
    this.fetchTemplates();
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to, from, next) {
    if (!this.composeDisabled) {
      this.ifShowLeaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  /**
   * @description 退出组件后销毁可编辑状态
   */
  private destroyed() {
    this.$store.commit("updateResearchListComposeDiabled", true);
  }
}
